// 营销邮件推荐状态
export const campaignPushStatusList = [
  {
    // 草稿
    title: "Draft",
    value: "DRAFT",
  },
  {
    // 待发送
    title: "Pending",
    value: "PENDING",
  },
  {
    // 发送中
    title: "Sending",
    value: "SENDING",
  },
  {
    // 发送成功
    title: "Success",
    value: "SUCCESS",
  },
  {
    // 发送失败
    title: "Failed",
    value: "FAILED",
  },
];
